// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#79818b","menuActiveText":"#000000","subMenuActiveText":"#f4f4f5","menuBg":"#ffffff","menuHover":"#263445","subMenuBg":"#1f2d3d","subMenuHover":"#001528","sideBarWidth":"260px"};
    if(module.hot) {
      // 1761558501448
      var cssReload = require("/Users/wumingbao/Desktop/hxproject/qingfa/erp-flexible-web21/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  